<template>
    <main id="mainCtrl">
        <header>
            <table class="grid" style="width: 100%" v-cloak>
                <tr v-if="networkClinics.length">
                    <td colspan="2">
                        <v-select
                            @select="update"
                            v-model="M.clinic_id"
                            class="large network-clinics-select"
                            style="max-width: 750px"
                            placeholder="Выберите клинику"
                            :options='networkClinics.map((clinic) => {return {value: clinic.id, text: clinic.name, fullAddress: clinic.fullAddress} })'
                        >
                            <template v-slot="{ option }">
                                <div class="textarea">
                                    <span>{{ option.text }}</span>
                                    <div style="height: 8px;"/>
                                    <small>{{ option.fullAddress }}</small>
                                </div>
                            </template>
                        </v-select>
                    </td>
                    <td align="right" colspan="2" v-cloak>
                        <img src="/img/metrikaLogo.30px.png" height="30" tooltip="Статистика предоставлена Яндекс.Метрика" style="margin-right: 6px">
                    </td>
                </tr>

                <tr>
                    <td width="500">
                        <date-range-picker ref="datepicker" @selected="setPeriod" :dateRangesPresets="periodOptions"/>
                    </td>
                    <td width="220" v-cloak>
                        <select v-model="M.group" @change="update" style="margin-bottom: 0;">
                            <option value="day">Детализация: по дням</option>
                            <option value="week">Детализация: по неделям</option>
                            <option value="month">Детализация: по месяцам</option>
                            <option value="year">Детализация: по годам</option>
                        </select>
                    </td>
                    <td width="200">
                        <a :href="getExportUrl()" target="_blank">
                            Экспорт в EXCEL
                        </a>
                    </td>
                    <td v-if="networkClinics.length"></td>
                    <td v-else align="right" v-cloak>
                        <img src="/img/metrikaLogo.30px.png" height="30" tooltip="Статистика предоставлена Яндекс.Метрика" style="margin-right: 6px">
                    </td>
                </tr>
            </table>
        </header>

        <div style="height: calc(100vh - 130px); overflow-x: hidden;" v-cloak>
            <h4>
                Переходы в анкеты врачей и клиники
            </h4>
            <div class="chart" id="visitsChart" @dblclick="updateVisits" :style="'min-height: ' + graphHeight + 'px;'"></div>

            <h4>
                Звонки и просмотры телефона
            </h4>
            <div class="chart" id="phonesChart" @dblclick="updatePhones" :style="'min-height: ' + graphHeight + 'px;'"></div>

            <h4>
                Переходы на сайт или социальные сети
            </h4>
            <div class="chart" id="sitesChart" @dblclick="updateSites" :style="'min-height: ' + graphHeight + 'px;'"></div>
        </div>
    </main>
</template>

<script>
import DateHelper from "../../components/base/DateHelper";

export default {
    props: {
        networkClinics: {
            type: Array,
            default: () => [],
        }
    },
    data: function () {
        return {
            M: {
                period: '-30 days | today',
                group: localStorage.getItem(window.location.pathname + '@M.group') ?? 'day',
                ajaxCounter: 0,
                clinic_id: this.networkClinics.length ? this.networkClinics[0].id : '',
            },
            visitsChart: [],
            phonesChart: [],
            sitesChart: [],
            graphHeight: 200,
            defaultPlaceholders: [
                'last monday | next sunday',
                'last monday -7 days | next sunday -7 days',
                '-30 days | today',
                'first day of this month | last day of this month',
                'first day of previous month | last day of previous month',
                '-3 months | today',
                'first day of january | last day of december',
            ],
            periodOptions: {
                thisWeek: {
                    title: 'Эта неделя',
                    value: 'last monday | next sunday',
                    date: () => DateHelper.getCurrentWeek(),
                },
                lastWeek: {
                    title: 'Прошлая неделя',
                    value: 'last monday -7 days | next sunday -7 days',
                    date: () => DateHelper.getPreviousWeek(),
                },
                lastThirtyDays: {
                    title: 'Последние 30 дней',
                    value: '-30 days | today',
                    date: () => DateHelper.getLastThirtyDays(),
                },
                thisMonth: {
                    title: 'Этот месяц',
                    value: 'first day of this month | last day of this month',
                    date: () => DateHelper.getCurrentMonth(),
                },
                lastMonth: {
                    title: 'Прошлый месяц',
                    value: 'first day of previous month | last day of previous month',
                    date: () => DateHelper.getPreviousMonth(),
                },
                lastThreeMonths: {
                    title: 'Последние 3 месяца',
                    value: '-3 months | today',
                    date: () => DateHelper.getLastThreeMonths(),
                },
                thisYear: {
                    title: 'Этот год',
                    value: 'first day of january | last day of december',
                    date: () => DateHelper.getCurrentYear(),
                },
            }
        };
    },
    methods: {
        setPeriod: function (data) {
            this.M.period = data ? data : '-30 days | today';

            if (this.defaultPlaceholders.indexOf(this.M.period) === -1) {
                localStorage.setItem(`${location.pathname}@customDateRange`, this.M.period);
            } else {
                localStorage.removeItem(`${location.pathname}@customDateRange`);
            }

            this.update();
        },

        update: function () {
            localStorage.setItem(window.location.pathname + '@M.group', this.M.group);

            this.M.ajaxCounter++;
            this.updateVisits();
            this.updatePhones();
            this.updateSites();
        },

        updateVisits: function () {
            let scope = this;
            document.getElementById('visitsChart').classList.add('loading')

            this.axios.post('statistics/visitsChart', this.M)
                .then(function (response) {
                    document.getElementById('visitsChart').classList.remove('loading')

                    if (response.data.status === 'OK') {
                        if (response.data.ajaxCounter === scope.M.ajaxCounter) {
                            scope.visitsChart = response.data.chart;
                            scope.drawChart(scope.visitsChart, document.getElementById('visitsChart'));
                            if (response.data.debugByDay) {
                                console.log('%cПереходы в анкеты врачей и клиники', 'font-size:x-large');
                                console.table(response.data.debugByDay);
                                if (scope.M.group !== 'day') {
                                    console.table(response.data.debugGrouped);
                                }
                            }
                        }
                    } else {
                        document.getElementById('visitsChart').innerHTML = 'Ошибка загрузки данных, попробуйте еще раз';
                    }
                })
                .catch(() => document.getElementById('visitsChart').classList.remove('loading'));
        },

        updatePhones: function () {
            let scope = this;
            document.getElementById('phonesChart').classList.add('loading')

            this.axios.post('statistics/phonesChart', this.M)
                .then(function (response) {
                    document.getElementById('phonesChart').classList.remove('loading')

                    if (response.data.status === 'OK') {
                        if (response.data.ajaxCounter === scope.M.ajaxCounter) {
                            scope.phonesChart = response.data.chart;
                            scope.drawChart(scope.phonesChart, document.getElementById('phonesChart'));
                            if (response.data.debugByDay) {
                                console.log('%cЗвонки и просмотры телефона', 'font-size:x-large');
                                console.table(response.data.debugByDay);
                                if (scope.M.group !== 'day') {
                                    console.table(response.data.debugGrouped);
                                }
                            }
                        }
                    } else {
                        document.getElementById('phonesChart').innerHTML = 'Ошибка загрузки данных, попробуйте еще раз';
                    }
                })
                .catch(() => document.getElementById('phonesChart').classList.remove('loading'));
        },

        updateSites: function () {
            let scope = this;
            document.getElementById('sitesChart').classList.add('loading')

            this.axios.post('statistics/sitesChart', this.M)
                .then(function (response) {
                    document.getElementById('sitesChart').classList.remove('loading')

                    if (response.data.status === 'OK') {
                        if (response.data.ajaxCounter === scope.M.ajaxCounter) {
                            scope.sitesChart = response.data.chart;
                            scope.drawChart(scope.sitesChart, document.getElementById('sitesChart'));
                            if (response.data.debugByDay) {
                                console.log('%cПереходы на сайт или социальные сети', 'font-size:x-large');
                                console.table(response.data.debugByDay);
                                if (scope.M.group !== 'day') {
                                    console.table(response.data.debugGrouped);
                                }
                            }
                        }
                    } else {
                        document.getElementById('sitesChart').innerHTML = 'Ошибка загрузки данных, попробуйте еще раз';
                    }
                })
                .catch(() => document.getElementById('sitesChart').classList.remove('loading'));
        },

        drawChart: function (data, $chart) {
            let chart = new google.visualization.ColumnChart($chart);
            let dataTable = google.visualization.arrayToDataTable(data);
            let view = new google.visualization.DataView(dataTable);

            if (data.length <= 40) {
                view.setColumns([0, 1, {calc: "stringify", sourceColumn: 1, type: "string", role: "annotation"}]);
            }
            google.visualization.events.addListener(chart, 'select', function () {
                chart.setSelection([{row: null}]);
            });

            chart.draw(view, this.chartDefaultOptions);
        },
        getExportUrl: function () {
            if (!this.networkClinics.length) {
                return '/clinics/statistics/export?group=' + this.M.group + '&period=' + this.M.period + '&counter=' + this.M.ajaxCounter;
            }

            return '/network/statistics/export?clinic_id=' + this.M.clinic_id + '&group=' + this.M.group + '&period=' + this.M.period + '&counter=' + this.M.ajaxCounter;
        }
    },
    mounted: function () {
        this.graphHeight = Math.max(150, (window.window.innerHeight - 250) / 3);
        let scope = this;

        google.charts.setOnLoadCallback(function () {
            scope.update();
        });

        window.addEventListener('resize', _.debounce(function () {
            scope.drawChart(scope.visitsChart, document.getElementById('visitsChart'));
            scope.drawChart(scope.phonesChart, document.getElementById('phonesChart'));
            scope.drawChart(scope.sitesChart, document.getElementById('sitesChart'));
        }, 100));

        if (!localStorage.getItem(`${location.pathname}@vuedatepicker`)) {
            if (localStorage.getItem(`${location.pathname}@customDateRange`)) {
                this.$refs.datepicker.placeholder = 'empty';
                let dateParts = localStorage.getItem(`${location.pathname}@customDateRange`).split('|');
                this.$refs.datepicker.start = dateParts[0].trim();
                this.$refs.datepicker.end = dateParts[1].trim();
            } else {
                for (const [key, item] of Object.entries(this.periodOptions)) {
                    if (item.value === this.M.period) {
                        this.$refs.datepicker.placeholder = key;
                        this.$refs.datepicker.setPlaceholderDateToInput();
                    }
                }
            }
        }
    },
    created() {
        google.charts.load('current', {
            packages: ['corechart'],
            name: 'visualization',
            version: '1.1',
            language: 'ru'
        });
    },
    computed: {
        chartDefaultOptions() {
            return {
                height: this.graphHeight,
                title: '',
                isStacked: true,

                displayLabels: false,
                displayAnnotations: false,
                annotations: {
                    textStyle: {
                        fontSize: 12,
                        color: '#000',
                        auraColor: 'none'
                    },
                    alwaysOutside: true,
                    stem: {
                        color: 'transparent',
                        length: 1
                    },
                },
                hAxis: {
                    textStyle: {
                        fontSize: 12,
                        color: '#000',
                        auraColor: 'none'
                    },
                    slantedText: false,
                    maxAlternation: 1,
                    maxTextLines: 1,
                },
                vAxis: {
                    textStyle: {
                        fontSize: 12,
                        color: '#000',
                        auraColor: 'transparent'
                    },
                    minValue: 0,
                    format: '#',
                    gridlines: {count: 4},
                    baseline: 0
                },
                colors: ['#71C37B', '#F9DB63', '#F06F6A', '#6B69CA', '#5291FA', '#F359AF', '#6BDDAC',],
                backgroundColor: 'transparent',

                seriesType: 'bars',
                series: {
                    2: {type: 'line', lineWidth: 0, displayAnnotations: true, visibleInLegend: false}
                },
                legend: 'none',
                chartArea: {
                    left: 50,
                    right: 0,
                    top: 5,
                    bottom: 30
                },
                bar: {
                    auraColor: 'transparent',
                    highContrast: true
                }
            };
        },
    },
}
</script>
